import { render, staticRenderFns } from "./general-section.vue?vue&type=template&id=13e8454d&scoped=true"
import script from "./general-section.vue?vue&type=script&lang=js"
export * from "./general-section.vue?vue&type=script&lang=js"
import style0 from "./general-section.vue?vue&type=style&index=0&id=13e8454d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e8454d",
  null
  
)

export default component.exports